// Short-lived stash for the `mfa_session` JWT returned by /auth/login when the
// user has 2FA enabled. We persist to sessionStorage so a tab refresh on
// /login/2fa can still complete the flow; the token itself is server-issued
// and short-lived, so leaking it to JS for the few seconds the second-factor
// form is open is acceptable. It is never written to localStorage.

const KEY = "finance.auth.mfa";

interface Stash {
  token: string;
  next: string;
}

export function rememberMfaSession(stash: Stash): void {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(stash));
  } catch {
    // sessionStorage can be unavailable (private mode in some browsers);
    // the in-memory navigate() state should still work for the happy path.
  }
}

export function readMfaSession(): Stash | null {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<Stash>;
    if (
      !parsed ||
      typeof parsed.token !== "string" ||
      typeof parsed.next !== "string"
    ) {
      return null;
    }
    return { token: parsed.token, next: parsed.next };
  } catch {
    return null;
  }
}

export function clearMfaSession(): void {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    // best effort
  }
}
